import { faDownload } from "@fortawesome/free-solid-svg-icons";
import saveAs from "file-saver";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useUserInfor } from "../../../../Context/User";
import {
    BaixarBoletoPDFESolutionController,
    GetArquivosBoletosDeListaParcela,
    GetBoletoPDFController,
} from "../../../../Controllers/Cobranca/ParcelasAbertas/ParcelasAbertasController";
import { GetClienteCompleto } from "../../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IParcelaBoletos } from "../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import { pdfMerger } from "../../../../Tools/PDFTools";
import IconOrSpinner from "../../../Utils/IconOrSpinner";
interface IBaixarBoletosSelecioadosProps {
    lstParcelasBoletos: Array<IParcelaBoletos>;
    bloquearBaixarBoleto: boolean;
    ID_CONTA?: number;
}
export default function BaixarBoletosSelecioados(
    props: IBaixarBoletosSelecioadosProps
) {
    const { lstParcelasBoletos, bloquearBaixarBoleto } = props;
    const { OrgInfor } = useUserInfor();

    const { Atendimento } = useAtendimentoPage();

    const eSolutionMode =
        OrgInfor.COD_ERP_INTEGRACAO === "ESOLUTION" ||
        OrgInfor.COD_ERP_INTEGRACAO === "ESOLUTION_LIVA";

    const {
        execute: BaixarBoletoPDFESolution,
        loading: BaixarBoletoPDFESolutionLoading,
    } = useAsyncCallback(BaixarBoletoPDFESolutionController);

    const { loading: baixando, execute: baixar } =
        useAsyncCallback(async () => {
            if (eSolutionMode) {
                if (lstParcelasBoletos)
                    BaixarBoletoPDFESolution(
                        Atendimento?.NR_CPF ?? "",
                        lstParcelasBoletos.map(
                            (lst) => lst.CODIGOBARRA
                        ) as string[]
                    ).then((res) => {
                        if (res) {
                            const pdfContent = atob(res);

                            const arrayBuffer = new ArrayBuffer(
                                pdfContent.length
                            );
                            const uint8Array = new Uint8Array(arrayBuffer);
                            for (let i = 0; i < pdfContent.length; i++) {
                                uint8Array[i] = pdfContent.charCodeAt(i);
                            }

                            const blob = new Blob([arrayBuffer], {
                                type: "application/pdf",
                            });

                            saveAs(blob, `Boletos.pdf`);
                        }
                    });
            } else {
                const lstArquivos = await GetArquivosBoletosDeListaParcela(
                    lstParcelasBoletos,
                    OrgInfor.COD_ERP_INTEGRACAO,
                    (B) => "",
                    String(Cliente?.NR_CPF)
                );
                if (lstArquivos) {
                    const ultraFile = await pdfMerger(...lstArquivos);
                    saveAs(ultraFile, "BOLETOS.pdf");
                }
            }
        }, [lstParcelasBoletos]);

    const {
        value: Cliente,
        // loading,
        // execute: update,
    } = useAsyncEffect(
        () => GetClienteCompleto(props.ID_CONTA ?? 0),
        [props.ID_CONTA]
    );

    const {
        loading: baixarBoletosNaoSelecionadosLoading,
        execute: baixarBoletosNaoSelecionados,
    } = useAsyncCallback(async () => {
        await GetBoletoPDFController({
            nrCpfCliente: String(Cliente?.NR_CPF),
            ID_PARCELA: 0,
            ID_VENDA: 0,
        }).then((res) => {
            if (res) {
                const pdfContent = atob(res);

                const arrayBuffer = new ArrayBuffer(pdfContent.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < pdfContent.length; i++) {
                    uint8Array[i] = pdfContent.charCodeAt(i);
                }

                const blob = new Blob([arrayBuffer], {
                    type: "application/pdf",
                });

                saveAs(blob, "BOLETOS.pdf");
            }
        });
    }, [Cliente]);

    return (
        <>
            <button
                className="d-flex align-items-center g-2 justify-content-center btn btn-sm btn-success w-100 w-md-auto"
                disabled={
                    baixando ||
                    BaixarBoletoPDFESolutionLoading ||
                    bloquearBaixarBoleto ||
                    lstParcelasBoletos.length === 0
                }
                onClick={baixar}
            >
                <IconOrSpinner
                    icon={faDownload}
                    loading={baixando}
                    loadingSize="sm"
                />
                Baixar boletos selecionados
            </button>
            {OrgInfor.COD_ERP_INTEGRACAO.toUpperCase() === "ESOLUTION" && (
                <button
                    className="d-flex align-items-center g-2 justify-content-center btn btn-sm btn-info w-100 w-md-auto"
                    disabled={baixarBoletosNaoSelecionadosLoading}
                    onClick={baixarBoletosNaoSelecionados}
                >
                    <IconOrSpinner
                        icon={faDownload}
                        loading={baixarBoletosNaoSelecionadosLoading}
                        loadingSize="sm"
                    />
                    Baixar boletos
                </button>
            )}
        </>
    );
}
